import { render, staticRenderFns } from "./bookMBA.vue?vue&type=template&id=75e0e880&scoped=true&"
import script from "./bookMBA.vue?vue&type=script&lang=js&"
export * from "./bookMBA.vue?vue&type=script&lang=js&"
import style0 from "./bookMBA.vue?vue&type=style&index=0&id=75e0e880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e0e880",
  null
  
)

export default component.exports